import React, { createContext, useContext, useEffect, useState } from 'react';
import client from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('viso_token');
    if (!token) { setLoading(false); return; }
    client.get('/auth/me')
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem('viso_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (company_email, password) => {
    const { data } = await client.post('/auth/login', { company_email, password });
    localStorage.setItem('viso_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await client.post('/auth/register', payload);
    localStorage.setItem('viso_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const registerPartner = async (payload) => {
    const { data } = await client.post('/partner/register', payload);
    localStorage.setItem('viso_token', data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('viso_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, registerPartner, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
